import React, { useState } from 'react'
import Selection from './Selection'
import { Box, ToggleButton, ToggleButtonGroup } from '@material-ui/core'
import FileUpload from './FileUpload'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
	toggleButton: {
		fontWeight: 600,
		border: 'none', // remove border
		textTransform: 'none',
		color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary,
		backgroundColor: 'transparent',
		'&.Mui-selected': {
			color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.main,
			backgroundColor: theme.palette.mode === 'dark' ? 'rgb(125, 110, 241)' : '#f3f0ff'
		},
		'&.Mui-selected:hover': {
			backgroundColor: theme.palette.mode === 'dark' ? '#4b4b4b' : '#e8e0ff'
		}
	}
}))

const Options = ({ handleClose, refreshData }) => {
	const [selectedOption, setSelectedOption] = useState('single')
	const classes = useStyles()

	const handleToggleChange = (event, newOption) => {
		if (newOption !== null) {
			setSelectedOption(newOption)
		}
	}

	return (
		<Box>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'flex-end'
					// mb: 2
				}}
			>
				<ToggleButtonGroup
					value={selectedOption}
					exclusive
					onChange={handleToggleChange}
					aria-label="question type selection"
				>
					<ToggleButton
						value="single"
						aria-label="single question"
						className={classes.toggleButton}
					>
						Single Question
					</ToggleButton>
					<ToggleButton
						value="multiple"
						aria-label="bulk questions"
						className={classes.toggleButton}
					>
						Bulk Upload
					</ToggleButton>
				</ToggleButtonGroup>
			</Box>

			<Box sx={{ width: '100%' }}>
				{selectedOption === 'single' && (
					<Selection handleClose={handleClose} refreshData={refreshData} />
				)}
				{selectedOption === 'multiple' && (
					<FileUpload handleClose={handleClose} refreshData={refreshData} />
				)}
			</Box>
		</Box>
	)
}

export default Options
